/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { Button } from "../../../..";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'modal-header';

/**
 * This is the component description.
 */
const ModalHeader = ({
  id,
  className: userClassName,
  style,
  title,
  close,
  color
  // ...otherProps
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: style
}, /*#__PURE__*/React.createElement("p", null, title), /*#__PURE__*/React.createElement(Button, {
  color: color,
  onClick: () => close(),
  isCompact: true,
  className: "close-button"
}, /*#__PURE__*/React.createElement("span", {
  className: "icon"
}, "Y")));
ModalHeader.propTypes = {
  /**
     * The HTML id for this element
     */
  id: PropTypes.string,
  /**
     * The HTML class names for this element
     */
  className: PropTypes.string,
  /**
     * The React-written, css properties for this element.
     */
  style: PropTypes.objectOf(PropTypes.string),
  /**
     *  The children JSX
     */
  title: PropTypes.string,
  /**
   *  The close modal function
   */
  close: PropTypes.func,
  /**
   *  The color for the button to open and close the modal
   */
  color: PropTypes.string.isRequired
};
ModalHeader.defaultProps = {
  // someProp:false
};
export default ModalHeader;